import { Container, Typography } from '@mui/material';

import Page from '../components/Page';
import SupplementaryOfferPage from '../components/SoPoMapping/SupplementaryOfferPage';

export default function SoPoMapping() {
  return (
    <Page title="Offer Mapping">
      <Container maxWidth="lg">
        <Typography variant="h4" gutterBottom>
          SO Mapping
        </Typography>

        <SupplementaryOfferPage />
      </Container>
    </Page>
  );
}
